import alt from "../alt";
import indexBy from "lodash/keyBy";
import values from "lodash/values";
import extend from "lodash/extend";
import VenueUtil from "../utils/VenueUtil";
import VenueActions from "../actions/VenueActions";
import EventBucketActions from "../actions/EventBucketActions";
import UserStore from "../stores/UserStore";

class VenueStore {
  constructor() {
    this.bindActions(VenueActions);

    this.state = {
      venues: {},
      isSaving: false,
      newVenueId: null,
      stagedData: {},
      isFetching: false
    };

    this.exportPublicMethods({
      getVenueById: this.getVenueById.bind(this),
      getVenuesForEventBucket: this.getVenuesForEventBucket.bind(this),
      isVenueComscoreEnabled: this.isVenueComscoreEnabled.bind(this),
    });
  }

  getVenueById(id) {
    return this.state.venues[id];
  }

  getVenuesForEventBucket(id) {
    return values(this.state.venues).filter(function(v) {
      return v.event_bucket === id;
    });
  }

  isVenueComscoreEnabled(id) {
    return this.state.venues[id].comscore_include === false ? false : true;
  }

  onFetchOne(id) {
    VenueUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        VenueActions.updateVenue(id, data);
      })
      .catch(VenueActions.fetchFailed);
  }

  onFetchAllForBucket(eventBucket) {
    this.setState({ isFetching: true });
    VenueUtil.fetchAllForBucket(UserStore.getState().apiKey, eventBucket)
      .then(data => {
        VenueActions.updateVenues(indexBy(data, "id"));
        this.setState({ isFetching: false });
      })
      .catch(VenueActions.fetchFailed);
  }

  onEdit(newData) {
    // Stage edit for next submit
    if (newData.stage) {
      this.setState({ stagedData: { [newData.id]: newData.values } });
      return;
    }

    if (this.state.stagedData[newData.id]) {
      newData.values = Object.assign(
        this.state.stagedData[newData.id],
        newData.values
      );
      delete this.state.stagedData[newData.id];
    }

    this.setState({ isSaving: true });
    VenueUtil.edit(UserStore.getState().apiKey, newData.id, newData.values)
      .then(data => {
        this.setState({ isSaving: false });
        VenueActions.updateVenue(newData.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
      })
      .catch(VenueActions.editFailed);
  }

  onDelete(id) {
    VenueUtil.delete(UserStore.getState().apiKey, id)
      .then(data => {
        EventBucketActions.fetchOne(this.state.venues[id].event_bucket);
        VenueActions.updateVenue(id, undefined);
      })
      .catch(VenueActions.editFailed);
  }

  onCreate(newData) {
    this.setState({
      newVenueId: null
    });

    VenueUtil.create(UserStore.getState().apiKey, newData)
      .then(data => {
        VenueActions.updateVenue(data.id, data);
        EventBucketActions.fetchOne(data.event_bucket);
        this.setState({
          newVenueId: data.id
        });
      })
      .catch(VenueActions.editFailed);
  }

  onUpdateVenue(data) {
    if (!data.venue) {
      delete this.state.venues[data.id];
    } else {
      this.state.venues[data.id] = data.venue;
    }
    this.state.newVenueId = null;
    this.setState(this.state);
  }

  onUpdateVenues(venues) {
    extend(this.state.venues, venues);
    this.setState(this.state);
  }

  onFetchFailed(e) {
    alert(`Fetching venue failed: ${e.message}`);
    throw e;
  }

  onEditFailed(e) {
    this.setState({ isSaving: false });
    alert(`Edit failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(VenueStore, "VenueStore");



// WEBPACK FOOTER //
// ./src/app/stores/VenueStore.js